import Image from 'global/Image';

import {
  ErrorContainer,
  ImageWrapper,
  RetryButton,
} from './ErrorFallback.styled';

export interface ErrorData {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError(): void;
}

const ErrorFallback = ({ errorData }: { errorData: ErrorData }) => (
  <ErrorContainer className="error-fallback">
    <ImageWrapper>
      <Image alt="" src="/images/empty-ufo.svg" width={120} />
    </ImageWrapper>
    <p>Load failed, please retry.</p>
    <RetryButton onClick={() => errorData.resetError()}>Retry</RetryButton>
  </ErrorContainer>
);

export default ErrorFallback;
